import {
  init,
  reactRouterV6BrowserTracingIntegration,
  replayIntegration,
  wrapUseRoutes,
} from "@sentry/react";
import { environment, sentryDsn } from "config";
import { useEffect } from "react";
import {
  RouteObject,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
  useRoutes,
} from "react-router-dom";

export const initSentry = () =>
  init({
    dsn: sentryDsn,
    environment: environment,
    replaysOnErrorSampleRate: 1.0,
    enableTracing: true,
    tracesSampleRate: 1.0,
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });

export const useSentryRoutes: (
  routes: RouteObject[],
  locationArg?: Partial<Location> | string,
) => React.ReactElement | null = wrapUseRoutes(useRoutes);
